import {useState, useEffect} from "react";
import dayjs, {Dayjs} from "dayjs";

/**
 * useCountdown
 * @param {Dayjs} targetDate - 목표 시간
 * @returns {string | null} - 남은 시간 "(dd일) hh:mm:ss" 형식 또는 null
 */
const useCountdown = (targetDate: Dayjs): string | null => {
	if (!dayjs.isDayjs(targetDate)) return null;
	const calculateTimeLeft = () => {
		const now = dayjs();
		const diff = targetDate.diff(now);

		if (diff <= 0) return null; // 목표 시간이 지나면 null 반환

		const days = Math.floor(diff / (1000 * 60 * 60 * 24));
		const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
		const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
		const seconds = Math.floor((diff % (1000 * 60)) / 1000);

		return `${days > 0 ? `${days}일 ` : ``}${hours >= 10 ? hours : `0${hours}`}:${
			minutes >= 10 ? minutes : `0${minutes}`
		}:${seconds >= 10 ? seconds : `0${seconds}`}`;
	};

	const [timeLeft, setTimeLeft] = useState<string | null>(calculateTimeLeft());

	useEffect(() => {
		const timer = setInterval(() => {
			const updatedTimeLeft = calculateTimeLeft();
			if (!updatedTimeLeft) clearInterval(timer); // 목표 시간이 지나면 타이머 종료
			setTimeLeft(updatedTimeLeft);
		}, 1000);

		return () => clearInterval(timer); // 클린업
	}, [targetDate]);

	return timeLeft;
};

export default useCountdown;
